import { useState } from "react";
import axios from "axios";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { AreaArquivo, Cartao, Etiqueta, Pagina } from "./ui/Painel";
import { CORES } from "../utils/participante";

const ImportarMesas = () => {
  const [arquivo, setArquivo] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState("");

  const handleImportar = async () => {
    if (!arquivo) return;

    setEnviando(true);
    setErro("");
    setResultado(null);

    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/participantes/importar-mesas`, formData);
      setResultado(data);
      setArquivo(null);
    } catch (error) {
      setErro(error.response?.data?.error || "Erro ao importar planilha de mesas.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Importações"
      titulo="Importar mesas"
      descricao="Envie a planilha (.xlsx) com nome, e-mail, distrital, mesa e número do ingresso. Quem já existe tem a mesa atualizada; quem não existe é cadastrado."
      largura={720}
    >
      <Cartao titulo="Planilha de mesas">
        <AreaArquivo
          arquivo={arquivo}
          onArquivo={setArquivo}
          accept=".xlsx,.xls"
          rotulo="Selecionar planilha (.xlsx)"
          dica="Clique ou arraste o arquivo para esta área"
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button variant="contained" onClick={handleImportar} disabled={!arquivo || enviando} sx={{ minWidth: 150 }}>
            {enviando ? <CircularProgress size={20} color="inherit" /> : "Importar mesas"}
          </Button>
        </Box>

        {erro && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {erro}
          </Alert>
        )}

        {resultado && (
          <Box sx={{ mt: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: 1 }}>
              {[
                ["Linhas", resultado.totalNaPlanilha],
                ["Mesas atualizadas", resultado.mesasAtualizadas],
                ["Já corretas", resultado.jaEstavaCorreto],
                ["Novos convidados", resultado.criados],
              ].map(([rotulo, valor]) => (
                <Box key={rotulo} sx={{ border: `1px solid ${CORES.borda}`, borderRadius: "8px", px: 1.5, py: 1.25 }}>
                  <Typography sx={{ fontSize: 11.5, color: CORES.textoSuave }}>{rotulo}</Typography>
                  <Typography sx={{ fontSize: 20, fontWeight: 800, color: CORES.navy }}>{valor ?? 0}</Typography>
                </Box>
              ))}
            </Box>
            <Alert severity="success">Importação concluída. Nenhuma linha foi descartada.</Alert>

            {resultado.distritalNaoReconhecido?.length > 0 && (
              <Alert severity="warning">
                <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1 }}>
                  {resultado.distritalNaoReconhecido.length} cadastrados na distrital "Não Identificada" — o nome da
                  distrital na planilha não foi reconhecido. Revise e ajuste manualmente:
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                  {resultado.distritalNaoReconhecido.map((item) => (
                    <Box key={item.codigo} sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                      <Etiqueta>{item.codigo}</Etiqueta>
                      <Typography sx={{ fontSize: 12.5 }}>
                        {item.nome} — distrital da planilha: "{item.distrital}"
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Alert>
            )}
          </Box>
        )}
      </Cartao>
    </Pagina>
  );
};

export default ImportarMesas;
